<div *ngIf="indoorIAQStatus.length" class="iaq-card-container" [ngStyle]="{'background-image':' url(' + getImageUrl() + ')'}">
  <div class="iaq-card-text-container">
    <span class="iaq-card-text">Indoor Air Quality is</span>
    <span class="iaq-card-quality">{{indoorIAQStatus}}</span>
  </div>
</div>

